// extracted by mini-css-extract-plugin
export default {"container":"MergeLists_container__yHjWy"};